import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { Opportunity } from 'app/services/opportunity/opportunity.model';
import { GetOpportunity } from './opportunity.actions';
import { catchError, tap } from 'rxjs/operators';
import { OpportunityService } from 'app/services/opportunity/opportunity.service';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

export class OpportunityStateModel {
  opportunity: Opportunity;
  loading: boolean;
}

@State<Partial<OpportunityStateModel>>({
  name: 'opportunity',
})
@Injectable()

export class OpportunityState {

  @Selector()
  static opportunity(state: OpportunityStateModel) {
    return state.opportunity;
  }

  @Selector()
  static loading(state: OpportunityStateModel) {
    return state.loading;
  }

  constructor(
    private opportunityService: OpportunityService,
  ) { }

  @Action(GetOpportunity)
  getOpportunity({ patchState }: StateContext<OpportunityStateModel>, { borrowerId }: GetOpportunity) {
    patchState({loading: true});
    return this.opportunityService.forBorrower(borrowerId).pipe(
      catchError(err => {
        patchState({loading: false});
        return throwError(err);
      }),
      tap(opportunity => {
        patchState({
          loading: false,
          opportunity
        });
      })
    );
  }
}
